import { render, staticRenderFns } from "./VerifyIdentityComponent.vue?vue&type=template&id=cae402ec&scoped=true&"
import script from "./VerifyIdentityComponent.vue?vue&type=script&lang=js&"
export * from "./VerifyIdentityComponent.vue?vue&type=script&lang=js&"
import style0 from "./VerifyIdentityComponent.vue?vue&type=style&index=0&id=cae402ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cae402ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cae402ec')) {
      api.createRecord('cae402ec', component.options)
    } else {
      api.reload('cae402ec', component.options)
    }
    module.hot.accept("./VerifyIdentityComponent.vue?vue&type=template&id=cae402ec&scoped=true&", function () {
      api.rerender('cae402ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/components/VerifyIdentityComponent.vue"
export default component.exports